module.exports = __webpack_public_path__ + "static/media/collection_page_2025_btn.58e70dc1.png";